import React from "react";

const TopCards = ({children}) => {
  const style = {
    box: {
      width: "50px",
      minWidth: "50px",
      height: "150px",
      transform: "translateY(23px) rotate(25deg)",
      marginLeft: "4px",
      marginTop: "-5px",
      display: 'flex',
    },
    boxText: {
      transform: "rotate(-90deg)",
      alignSelf: "center",
      width: "50px",
      display: "flex",
      justifyContent: "center",
      // marginLeft: "-30%",
    }
  };

  return (
    <div>
      <div style={style.box} className="bg-white border">
        <div style={style.boxText}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default TopCards;